// src/components/StatCard.tsx
import React from 'react';
import { Card, Typography } from 'antd';
import './StatCard.css';

type Props = {
  title: string;
  value: React.ReactNode;
  suffix?: React.ReactNode;
  icon?: React.ReactNode;
  accent?: boolean;          // делает карточку с градиентом
  deltaText?: string;        // например “+40%”
  deltaHint?: string;        // “this month”
  linkText?: string;         // “View All”
  onLink?: () => void;
  blueAccent?: boolean;      // синий градиент
  className?: string;
};

const StatCard: React.FC<Props> = ({
  title, value, suffix, icon, accent = false,
  deltaText, deltaHint, linkText, onLink,
  blueAccent, className
}) => {
  const cls =
    `stat-card ${accent ? 'stat-card--accent' : ''} ${blueAccent ? 'stat-card--accent-blue' : ''} ${className ?? ''}`;

  return (
    <Card
      className={cls}
      variant="borderless"                 // вместо устаревшего bordered={false}
      styles={{ body: { padding: 16 } }}   // при необходимости подправь отступ
    >
      <div className="stat-card__top">
        <div className="stat-card__icon">{icon}</div>
        <div className="stat-card__meta">
          <Typography.Text className="stat-card__title">{title}</Typography.Text>
          <div className="stat-card__value">
            <span>{value}</span>
            {suffix ? <span className="stat-card__suffix">{suffix}</span> : null}
          </div>
        </div>
      </div>

      <div className="stat-card__bottom">
        {linkText && (
          <button className="stat-card__link" onClick={onLink} type="button">
            {linkText} →
          </button>
        )}
        {(deltaText || deltaHint) && (
          <div className="stat-card__delta">
            <span className={`stat-card__delta-badge ${String(deltaText).startsWith('+') ? 'up' : 'down'}`}>
              {deltaText}
            </span>
            <span className="stat-card__delta-hint">{deltaHint}</span>
          </div>
        )}
      </div>
    </Card>
  );
};

export default StatCard;
